export enum CashbackVariant {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export enum CashbackStatuses {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export interface CashbackValue {
  id: string;
  triggerId: string;
  source: string;
  userId: number;
  rewardId: string;
  cashbackVariant: CashbackVariant;
  status: CashbackStatuses;
  value: number;
  currency: string;
}

export interface CashbackInfo {
  id: string;
  name: string;
  authorId: number;
  variant: "cashback";
  cashbackVariant: CashbackVariant;
  currency: string;
  wager: number;
  wageringTerm: number;
  minCashback: Record<string, number>;
  maxCashback: Record<string, number>;
  ignoreGameIds: string[];
  ignoreProductNames: string[];
  ignoreProviderNames: string[];
  wagerGameIds: string[];
  wagerProductNames: string[];
  wagerProviderNames: string[];
  textAfterReceivingAward: string;
  textBeforeReceivingAward: string;
  hasLock: boolean;
  deletedAt?: string;
  percent: number;
}

export interface CashbackLoyaltyReward {
  id: string;
  currency: string;
  loyaltyId: string;
  rewardId: string;
  rewardType: number;
  status: string;
  updatedAt: string;
  createdAt: string;
  userId: number;
  rankIndex?: number;
  levelIndex?: number;
}

export type CashbackResponseInner = {
  rewardCashback: CashbackInfo;
  rewardCashbackValue: CashbackValue;
  loyaltyReward: CashbackLoyaltyReward;
};
